import { useState, createRef } from "react";
import Dropzone from "react-dropzone";
import {
  Tooltip,
  VStack,
  Editable,
  EditableInput,
  Box,
  EditablePreview,
  Button,
  ButtonGroup,
  IconButton,
  Flex,
  useColorModeValue,
} from "@chakra-ui/react";
import { FiEdit, FiCheckSquare } from "react-icons/fi";
import { CgCloseR } from "react-icons/cg";
const baseStyle = {
  flex: 1,
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  padding: "5rem",
  color: "#bdbdbd",
  outline: "none",
  transition: "border .24s ease-in-out",
  width: "90vw",
  justifyContent: "flex-end",
};
const dropzoneRef = createRef();
const openDialog = () => {
  // Note that the ref is set async,
  // so it might be null at some point
  if (dropzoneRef.current) {
    dropzoneRef.current.open();
  }
};
function EditableControls({ isEditing, onSubmit, onCancel, onEdit }) {
  return isEditing ? (
    <ButtonGroup justifyContent="center" size="sm">
      <IconButton
        icon={<FiCheckSquare />}
        onClick={onSubmit}
        aria-label="Check"
      />
      <IconButton icon={<CgCloseR />} onClick={onCancel} aria-label="Close" />
    </ButtonGroup>
  ) : (
    <Flex justifyContent="center">
      <IconButton size="sm" icon={<FiEdit />} onClick={onEdit} />
    </Flex>
  );
}
export function DropZone() {
  const bg = useColorModeValue("#fafafa", "#555F73");
  const [files, setFiles] = useState([]);
  const [Dropped, setDropped] = useState(false);
  // const [FilePreview, setFilePreview] = useState([]);
  // console.log(files);
  // console.log(Dropped);

  return (
    <Tooltip
      label="File upload Size limit is 16MB"
      aria-label="A tooltip"
      bg="gray.300"
      color="black"
      placement="auto"
    >
      <VStack
        borderRadius={4}
        bg={bg}
        w="100%"
        // h="60vh"
        justifyItems="center"
        justifyContent="center"
        textAlign="center"
      >
        {Dropped ? (
          files.map((file, id) => {
            console.log(file);
            return (
              <Box key={id} bg="tomato" color="#fcfcfc" w={"80%"} my={[4, 8]}>
                <p>accepted files</p>
                <Editable
                  defaultValue={file.name.split(".")[0]}
                  fontSize="2xl"
                  isPreviewFocusable={false}
                  submitOnBlur={false}
                >
                  {(props) => (
                    <>
                      <EditablePreview />
                      <EditableInput />
                      <EditableControls {...props} />
                    </>
                  )}
                </Editable>
                <br />
              </Box>
            );
          })
        ) : (
          <Dropzone
            // ref={dropzoneRef}
            onDrop={(acceptedFiles) => {
              setFiles([...files, ...acceptedFiles]);
              setDropped(true);
            }}
            maxSize={16777216}
            accept={"image/*"}
          >
            {({ getRootProps, getInputProps }) => (
              <div style={baseStyle} {...getRootProps()}>
                <input {...getInputProps()} />
                <strong>
                  Drag n drop some files here, or click to select{" "}
                </strong>
                <br />
                <Button aria-label="Add Files" colorScheme="blue" type="button" onClick={openDialog()}>
                  Add Files
                </Button>
              </div>
            )}
          </Dropzone>
        )}
      </VStack>
    </Tooltip>
  );
}
